
import { useEffect } from "preact/hooks";
 import PhotoSwipeLightbox from 'photoswipe/lightbox';
 import 'photoswipe/style.css';

 import { selector } from "../settings";

 const transformMwlData = (mwlData) => {
   return Object.values(mwlData).map(item => ({
     id: item.data.id,
     src: item.file,
     msrc: item.file,  
     width: item.dimension.width,
     height: item.dimension.height,
     thumbCropped: true
   }));
 };

 export default function PhotoSwipeCore() {
   useEffect(() => {
     const transformedData = transformMwlData(window.mwl_data);

     const classes = selector.split(',').map(className => className.trim() + " img");
     const fullSelector = classes.join(', ');

     try {
       let lightbox = new PhotoSwipeLightbox({
         dataSource: transformedData,
         showHideAnimationType: 'zoom',
         pswpModule: () => import('photoswipe'),
       });

       lightbox.addFilter('thumbEl', (thumbEl, data, index) => {
         let el = document.querySelector(`[data-mwl-img-id='${data.id}']`);

         if (!el) {
             el = document.querySelector('.wp-image-' + data.id);
         }

         if (el) {
           return el;
         }
         return thumbEl;
       });

       lightbox.addFilter('placeholderSrc', (placeholderSrc, slide) => {
         let el = document.querySelector(`[data-mwl-img-id='${slide.data.id}']`);

         if (!el) {
             el = document.querySelector('.wp-image-' + slide.data.id);
         }

         if (el) {
           return el.src;
         }
         return placeholderSrc;
       });


       lightbox.init();

       // Expose to use within onclick attribute
       window.pswpLightbox = lightbox;

       // Add click event listeners to the images
       const images = document.querySelectorAll(fullSelector);
       images.forEach((img) => {

         let id = null;
         id = img.attributes['data-mwl-img-id']?.value;

         if( !id ) {
           console.warn('No data-mwl-img-id found. Attempting to find ID from class name');
           const classes = img.className.split(' ');
           id = classes.find((className) => className.includes('wp-image-'));
           id = id.split('-')[2];
         }

         const index = transformedData.findIndex((item) => item.id == id)

         img.addEventListener('click', () => {
           lightbox.loadAndOpen(index);
         });
       });

     } catch (error) {
       console.error("Error initializing PhotoSwipe:", error);
     }

     return () => {
       if (lightbox) {
         lightbox.destroy();
         lightbox = null;
       }
     };
   }, []);

   return (<></>);
 }